import ClipboardController from './clipboard_controller'

// A pane (CodePaneHelper): one copy button on its strip, a name that opens
// and shuts the pane where it is collapsible, and in a code pane objects and
// lists that fold from their first line.
//
// The copy lifts what the body holds in the form it reads best pasted: a code
// pane line by line (folded lines included, line numbers left out, since they
// are CSS), ledger lines as "Label: value", anything else as its text.
export default class extends ClipboardController {
  static targets = ['body']

  get copyText () {
    if (!this.hasBodyTarget) return super.copyText

    const lines = this.bodyTarget.querySelectorAll('.run-code__text')
    if (lines.length) return [...lines].map(line => line.textContent).join('\n')

    // Ledger lines paste as "Label: value"; diff lines as a unified diff, the
    // label on its own line over its "- old" and "+ new".
    const rows = this.bodyTarget.querySelectorAll('.review-diff__line')
    if (rows.length) {
      return [...rows].flatMap(row => {
        const label = row.querySelector('.review-diff__label')?.textContent.trim()
        const value = row.querySelector('.review-diff__text')?.textContent.trim()
        const sign = row.dataset.sign
        if (sign === '-' || sign === '+') return label ? [label, `${sign} ${value}`] : [`${sign} ${value}`]
        return [label ? `${label}: ${value}` : value]
      }).join('\n')
    }

    return this.bodyTarget.textContent.trim()
  }

  // The strip's name opens and shuts the whole pane.
  toggle (event) {
    event.preventDefault()
    const collapsed = !this.element.hasAttribute('data-collapsed')
    this.element.toggleAttribute('data-collapsed', collapsed)
    event.currentTarget.setAttribute('aria-expanded', String(!collapsed))
  }

  fold (event) {
    event.preventDefault()
    const button = event.currentTarget
    const line = button.closest('.run-code__line')
    const folded = !line.hasAttribute('data-folded')
    line.toggleAttribute('data-folded', folded)
    button.setAttribute('aria-expanded', String(!folded))
    button.title = folded ? 'Unfold' : 'Fold'
    this.applyFolds()
  }

  // A line is hidden while a folded line above it reaches past it. Worked out
  // from the top every time, so a block folded inside a block stays folded
  // when the outer one opens again.
  applyFolds () {
    let hiddenUntil = 0
    this.bodyTarget.querySelectorAll('.run-code__line').forEach(line => {
      const number = Number(line.dataset.line)
      line.hidden = number <= hiddenUntil
      if (!line.hidden && line.hasAttribute('data-folded')) {
        hiddenUntil = Math.max(hiddenUntil, Number(line.dataset.foldEnd))
      }
    })
  }
}
